import { CSSObject } from '@chakra-ui/react';
import { CustomButtonProps } from '@/components/Button/Button';

export const buttonRunnerPropositionButtonProps: CustomButtonProps = {
  w: '14',
  _disabled: {
    borderWidth: '2px',
    borderStyle: 'solid',
    borderColor: 'white',
    bg: 'gray.300',
    borderRadius: 'md',
    color: 'blackAlpha.400',
    fontWeight: 'bold',
    fontSize: 'sm',
    boxShadow:
      '0px 0px 0px 2px rgba(0, 0, 0, 0.20) inset, 0px 2px 6px 0px rgba(0, 0, 0, 0.35)',
    cursor: 'not-allowed',
    pointerEvents: 'none',
  },
};

export const favouriteFlexProps: CSSObject = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '0.5',
  py: '0.5',
  width: '100%',
  maxH: 'calc(var(--bc-space-3) + 4px)',
  marginRight: '-2px',
  marginLeft: '-2px',
  position: 'absolute',
  top: '-2px',
  borderTopLeftRadius: '5px',
  borderTopRightRadius: '5px',
  borderTop: '1px solid rgba(255, 255, 255, 0.10)',
  borderRight: '1px solid rgba(255, 255, 255, 0.10)',
  borderLeft: '1px solid rgba(255, 255, 255, 0.10)',
  bgGradient: 'linear(to-b, alpha.500, alpha.700)',
};

export const favouriteIconProps: CSSObject = {
  boxSize: '2',
  color: 'beta.500',
};

export const favouriteTextProps: CSSObject = {
  fontSize: '2xs',
  color: 'beta.500',
  textShadow: 'none',
};
